import Vue from "vue";
import VueGAPI from "vue-gapi";

const apiConfig = {
  apiKey: "AIzaSyBJXqdebidI4cPzdxjc3bBbOYkijjx5kc0",
  clientId:
    "963122612671-pf1gtrg4ta79rddsf6sgj9pg6o2mhb91.apps.googleusercontent.com",
  discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"],
  scope:
    "https://www.googleapis.com/auth/drive.file profile https://www.googleapis.com/auth/drive"
};

Vue.use(VueGAPI, apiConfig);
